import api from '../utils/api';

const hrRecruitmentService = {
  vacancies: () => api.get('/api/hr/recruitment/vacancies'),
  createVacancy: data => api.post('/api/hr/recruitment/vacancies', data),
  updateVacancy: (id, data) => api.patch(`/api/hr/recruitment/vacancies/${id}`, data),
  applicants: (status) => api.get('/api/hr/recruitment/applicants', { params: status ? { status } : {} }),
  createApplicant: data => api.post('/api/hr/recruitment/applicants', data),
  updateApplicantStatus: (id, data) => api.patch(`/api/hr/recruitment/applicants/${id}/status`, data),
  hireApplicant: (id, data) => api.post(`/api/hr/recruitment/applicants/${id}/hire`, data),
  interviews: () => api.get('/api/hr/recruitment/interviews'),
  scheduleInterview: data => api.post('/api/hr/recruitment/interviews', data),
  recordInterviewResult: (id, data) => api.patch(`/api/hr/recruitment/interviews/${id}`, data),
  offers: () => api.get('/api/hr/recruitment/offers'),
  createOffer: data => api.post('/api/hr/recruitment/offers', data),
  updateOfferStatus: (id, data) => api.patch(`/api/hr/recruitment/offers/${id}/status`, data),
  getOfferPdf: (id) => api.get(`/api/hr/recruitment/offers/${id}/pdf`, { raw: true }),
};

export default hrRecruitmentService;